var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReferral = function SvgReferral(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "#243038"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6667 14C24.6667 11.4227 22.5773 9.33331 20 9.33331C17.4227 9.33331 15.3333 11.4227 15.3333 14C15.3333 16.5773 17.4227 18.6666 20 18.6666C22.5773 18.6666 24.6667 16.5773 24.6667 14ZM12.7067 13.2266C12.1067 12.8666 11.4133 12.6666 10.6667 12.6666C8.45753 12.6666 6.66667 14.4575 6.66667 16.6666C6.66667 18.8758 8.45753 20.6666 10.6667 20.6666C12.2133 20.6666 13.5467 19.7866 14.2133 18.5066C13.0667 17.0266 12.5067 15.1333 12.7067 13.2266ZM29.3333 12.6666C31.5425 12.6666 33.3333 14.4575 33.3333 16.6666C33.3333 18.8758 31.5425 20.6666 29.3333 20.6666C27.7867 20.6666 26.4533 19.7866 25.7867 18.5066C26.9333 17.0266 27.4933 15.1333 27.2933 13.2266C27.8933 12.8666 28.5867 12.6666 29.3333 12.6666ZM20 21.3333C15.2133 21.3333 12 23.5733 12 26.3333V29.3333H28V26.3333C28 23.5733 24.7867 21.3333 20 21.3333ZM4 29.3333V26.6666C4 24.8133 7.18667 23.2533 10.6 22.8C9.81333 23.7066 9.33333 24.96 9.33333 26.3333V29.3333H4ZM30.6667 29.3333H36V26.6666C36 24.8133 32.8134 23.2533 29.4 22.8C30.1867 23.7066 30.6667 24.96 30.6667 26.3333V29.3333Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReferral, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/referral.731293fd.svg";
export { ForwardRef as ReactComponent };